export default __webpack_public_path__ + "static/bot-63e2792fffc4f9326e038578b7b9540d.svg";